import React, { useEffect, useState } from "react";
import { Layout as AntdLayout, Button, theme, Breadcrumb } from "antd";
import { LeftOutlined, RightOutlined, UserOutlined } from "@ant-design/icons";
import clsx from "clsx";
import { useMediaQuery } from "react-responsive";
import { NavLink } from "react-router";
import Menu from "./Menu";
import ReduxRedirect from "../Common/ReduxRedirect";
import { MainLogo, MainLogoSecondary } from "../Common/Icon";
import LanguageSwitcher from "../Common/LanguageSwitcher";
import { useAuth } from "../../store/auth";
import NotificationDropdown from "../Common/NotificationMenu";
import { BreadcrumbsProvider, useBreadcrumbs } from "../../context/breadcrumbs";

import styles from "./index.module.scss";
import UserMenu from "./UserMenu";

const { Sider, Header, Content } = AntdLayout; // Header

interface LayoutProps {
  LeftMenu?: React.FC;
  leftMenu?: React.ReactNode;
  transparent?: boolean;
  disableLeftMenu?: boolean;
  children: React.ReactNode;
  collapsedByDefault?: boolean;
  minWidth?: boolean;
  title?: string;
}

let defaultStateCollapsed = false;

const LayoutBreadcrumbs = () => {
  const { breadcrumbs } = useBreadcrumbs();
  return (
    <Breadcrumb style={{ marginBottom: 0 }}>
      {breadcrumbs.map((item, index) => (
        <Breadcrumb.Item key={index}>
          {item.href ? (
            <NavLink to={item.href}>{item.title}</NavLink>
          ) : (
            item.title
          )}
        </Breadcrumb.Item>
      ))}
    </Breadcrumb>
  );
};

function Layout({
  disableLeftMenu = false,
  LeftMenu,
  leftMenu = <Menu />,
  transparent,
  children,
  collapsedByDefault = false,
  minWidth,
  title,
}: LayoutProps): React.ReactNode {
  const [collapsed, setCollapsed] = useState(defaultStateCollapsed);
  const {
    token: { colorBgContainer },
  } = theme.useToken();
  const isTablet = useMediaQuery({
    query: "(max-width: 1024px)",
  });
  const disableMenu = disableLeftMenu || (!LeftMenu && !leftMenu);
  const { user } = useAuth();

  useEffect(() => {
    (window as any).__unsavedChangesGuard = null;

    return () => {
      (window as any).__unsavedChangesGuard = null;
    };
  }, []);

  useEffect(() => {
    defaultStateCollapsed = collapsed;
  }, [collapsed]);

  useEffect(() => {
    if ((isTablet && !disableMenu) || collapsedByDefault) {
      setCollapsed(true);
    } else {
      setCollapsed(false);
    }
  }, [isTablet, disableMenu]);

  return (
    <>
      <ReduxRedirect />
      <AntdLayout hasSider className={styles.layout}>
        {disableMenu ? null : (
          <Sider
            trigger={null}
            collapsible
            collapsed={collapsed}
            className={clsx(styles.slider, {
              [styles.absolute]: isTablet && !disableMenu,
            })}
            width="var(--side-menu-w)"
            collapsedWidth="var(--side-menu-collapsed-w)"
          >
            <NavLink
              to="/"
              className={clsx(styles.logo, { [styles.collapsed]: collapsed })}
            >
              {collapsed ? <MainLogoSecondary /> : <MainLogo />}
              {/* {collapsed ? <img src="/logo.png" className={styles.logoSvg} alt="Triare" /> : null}*/}
              {/* <LogoMini className={styles.logoSvg} /> */}

              {/*{!collapsed ? <img src="/logo.png" className={styles.logoSvg} alt="Triare" /> : null}*/}
              {/* <Logo className={styles.logoSvg} /> */}
            </NavLink>
            <div
              className={clsx(styles.sideMenu, {
                [styles.collapsed]: collapsed,
              })}
            >
              {LeftMenu ? <LeftMenu /> : leftMenu}
            </div>
            <div
              // style={{
              //   display: "flex",
              //   justifyContent: "center",
              //   width: "100%",
              //   height: 48,
              //   borderTop: "1px solid #0000000F",
              // }}
              className={styles.colapseBtn}
              role="button"
              tabIndex={0}
              onClick={() => setCollapsed(!collapsed)}
            >
              {collapsed ? (
                <RightOutlined style={{ color: "#00000073" }} />
              ) : (
                <LeftOutlined style={{ color: "#00000073" }} />
              )}
            </div>
          </Sider>
        )}
        <BreadcrumbsProvider>
          <AntdLayout
            className={clsx(styles.wrapper, {
              [styles.tablet]: isTablet && !disableMenu,
            })}
          >
            <Header
              style={{ background: colorBgContainer }}
              className={clsx(styles.header)}
            >
              <LayoutBreadcrumbs />
              <div className={styles.rightMenu}>
                {/* <div className={styles.userLogo}>
                  <UserOutlined style={{ color: "#FFFFFF" }} />
                </div>
                {user?.email} */}
                <UserMenu />
              </div>
            </Header>
            {/*<Header
            style={{ background: colorBgContainer }}
            className={clsx(styles.header, {
              [styles.headerLogo]: disableMenu,
            })}
          >
            {disableMenu ? (
              <NavLink
                to="/"
                className={clsx(styles.logo, { [styles.tablet]: isTablet })}
              >
                {collapsed ? (
                  <img
                    src="/logo.png"
                    className={styles.logoSvg}
                    alt="Triare"
                  />
                ) : null}
                <MainLogo className={styles.logoSvg} />

                {!collapsed ? (
                  <img
                    src="/logo.png"
                    className={styles.logoSvg}
                    alt="Triare"
                  />
                ) : null}
                <MainLogo className={styles.logoSvg} />
              </NavLink>
            ) : null}

            Header items should be here:
            <Menu />
          </Header>*/}

            <div
              className={clsx(styles.scroll, {
                [styles.collapsed]: collapsed,
              })}
            >
              <Content
                className={clsx(
                  styles.content,
                  { [styles.transparent]: transparent },
                  { [styles.minWidth]: isTablet && minWidth },
                )}
                id="layout-content"
              >
                {title ? (
                  <div className={styles.title}>
                    <h2>{title}</h2>
                  </div>
                ) : null}
                {children}
              </Content>
            </div>
          </AntdLayout>
        </BreadcrumbsProvider>
      </AntdLayout>
    </>
  );
}

export default Layout;
